import { useSyncState } from '@/hooks/hooks';
import { useServices } from '@/app/services';
import { Icon } from '@/ui/Icon';

const LABELS = {
  idle: 'Synchronisiert',
  syncing: 'Synchronisiere …',
  offline: 'Offline – Änderungen werden lokal gespeichert',
  error: 'Synchronisierung fehlgeschlagen',
} as const;

/** Small status button showing the sync state; click syncs now. */
export function SyncIndicator() {
  const { sync } = useServices();
  const state = useSyncState();
  const icon = state.status === 'offline' || state.status === 'error' ? 'cloud_off' : state.status === 'syncing' ? 'sync' : 'cloud_done';
  return (
    <button
      type="button"
      className={`sync-indicator is-${state.status}`}
      onClick={() => void sync.sync()}
      aria-label={LABELS[state.status]}
      title={LABELS[state.status]}
    >
      <Icon name={icon} size={20} />
    </button>
  );
}
